import React from 'react'

import { ListGroup } from 'components'

export const QuestionListGroup = ({ ...props }) => <ListGroup dndScope='question' {...props} />

export default QuestionListGroup
